<template>
    <div class="card-container">
        <common-top-form :model="formModel" @openAddDialog="add" buttonName="充值" :submitService="submitService"
                         :submitData="submitData" @success="onSuccess"
                         :cutButton="true" @cut="deduction" addShowPower="/fin/saveRecharge_add"
                         cutShowPower="/fin/saveRecharge_cut"
                         downloadPower="/fin/rechargeExport" showDownloadPowerType="warning" @down="handleExport"
                         :showDownloadPower="true"
                         uploadPowerType="purple" uploadPowerText="合计" uploadPower="/statistics/qpayInfoQry"
                         @upload="upload">
            <select-organs v-model="formModel.tatSimpleId"></select-organs>
            <el-form-item label="交易类型">
                <el-select v-model="formModel.tranType">
                    <el-option
                        v-for="item in tranTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="充值时间">
                <el-date-picker
                    v-model="formModel.time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column prop="tatSimpleId" label="机构简称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="tranType" label="交易类型" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{scope.row.tranType == 1 ? '充值' : '扣款'}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="rechargeType" label="账号类型" min-width="100" :formatter="formatRechargeType"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="tranAmt" label="交易金额（元）" min-width="130" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{toDoubleThousands(scope.row.tranAmt *100 / 10000)}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="100" show-overflow-tooltip></el-table-column>
            <!--<el-table-column prop="optUserid" label="操作人"></el-table-column>-->
            <el-table-column prop="optTime" label="操作时间" min-width="160"></el-table-column>
        </common-table>
        <form-dialog ref="formDialog" :formDialogTitle="formDialogTitle" :model="dialogModel"
                     :submitData="dialogData" :rules="dialogRules" :dialogService="dialogService"
                     class="over" @success="dialogSuccess" @close="dialogClose" labelWidth="100px"
                     :show="tranType != 3" @opend="dialogOpen">
            <div v-if="tranType == 3">
                <p>交易金额：{{toDoubleThousands(dialogAmount)}}元</p>
            </div>
            <div v-else>
                <select-organs v-model="dialogModel.tatSimpleId" :selectValue="dialogModel.tatSimpleId" :needAll="false"
                               selectWidth="100%"></select-organs>

                <el-form-item label="账号类型" prop="rechargeType">
                    <el-select v-model="dialogModel.rechargeType">
                        <el-option
                            v-for="item in rechargeTypes"
                            :key="item.dictKey"
                            :label="item.dictValue"
                            :value="item.dictKey">
                        </el-option>
                    </el-select>
                </el-form-item>
                <p class="notice"><span>充值类型</span>{{tranType == 1 ? '充值' : '扣款'}}</p>
                <el-form-item label="充值金额" prop="tranAmt">
                    <div class="flex-row">
                        <el-input-number controls-position="right" :precision="2" :step="0.1" :min="0" :controls="false"
                                         v-model="dialogModel.tranAmt" style="width: 100%"></el-input-number>
                        <span class="formSpan">元</span>
                    </div>
                </el-form-item>
                <el-form-item label="备注" prop="content">
                    <el-input maxlength="80" show-word-limit type="textarea" resize="none" rows="4"
                              v-model="dialogModel.remark"></el-input>
                </el-form-item>
            </div>

        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import SelectOrgans from 'components/business/SelectOrgans'
    import FormDialog from '../../dialog/FormDialog'

    import FinanceService from 'service/FinanceService'
    import OrganService from 'service/OrganService'
    import StatisticsService from 'service/StatisticsService'
    import privateKey from 'service/constant/privateKey';
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'
    import TimeRange from 'service/constant/TimeRange'


    export default {
        name: "servicemanage",
        components: {
            CommonTopForm, CommonTable, FormDialog, SelectOrgans
        },
        data() {
            return {
                formModel: {
                    tatSimpleId: '',
                    tranType: '',
                    time: TimeRange.dayRange,
                },
                all: [{
                    id: '',
                    simpleName: '全部'
                }],
                tranTypes: [{
                    value: '',
                    label: '全部'
                }, {
                    value: '1',
                    label: '充值'
                }, {
                    value: '2',
                    label: '扣款'
                }],
                submitService: FinanceService.getRecharges,
                tableData: [],
                formDialogTitle: '',
                dialogRules: {
                    tatSimpleId: [{
                        required: true,
                        message: '请选择机构简称'
                    }],
                    rechargeType: [{
                        required: true,
                        message: '请选择账号类型'
                    }],
                    tranAmt: [{
                        required: true,
                        message: '请输入金额'
                    }],
                },
                dialogModel: {
                    tatSimpleId: '',
                    tranAmt: '',
                    remark: '',
                    rechargeType: '',
                },
                rechargeTypes: [],
                time: TimeRange.dayRange,
                page: {},
                params: {},
                dialogAmount: 0,
                tranType: '',
                isPage: false,
                dialogService: FinanceService.saveRecharge
            }
        },
        mixins: [loadMixin, dialogMixin],
        mounted() {
            this.page = this.$refs.commonTable.page;
            this.getTypeNames('充值类型', (res) => {
                this.rechargeTypes = res;
            });
            this.getList();
        },
        computed: {
            submitData() {
                if (this.formModel.time == null || this.formModel.time == '') {
                    this.formModel.time = [];
                }
                this.params = {
                    tatSimpleId: this.formModel.tatSimpleId,
                    tranType: this.formModel.tranType,
                    startDate: this.formModel.time[0],
                    endDate: this.formModel.time[1],
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };

                if (this.formModel.time.length == 0) {
                    delete this.params.startDate;
                    delete this.params.endDate;
                }

                return this.params;
            },
            dialogData() {
                const params = {
                    tatSimpleId: this.dialogModel.tatSimpleId,
                    rechargeType: this.dialogModel.rechargeType,
                    tranType: this.tranType,
                    tranAmt: this.dialogModel.tranAmt,
                    remark: this.dialogModel.remark,
                    optUserid: this.userId,
                };
                return params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId']),
        },
        methods: {
            upload() {
                this.dialogAmount = 0;
                this.tranType = 3;
                this.formDialogTitle = '合计';
                this.$refs.formDialog.open();
            },
            handleExport() {
                this.limitExport(this.page.total) ? StatisticsService.exportExcel(this.submitData, 'rechargeExport', '', '/fin/') : ''
            },
            add() {
                this.formDialogTitle = '认证充值';
                this.tranType = 1;
                this.$refs.formDialog.open();
            },
            deduction() {
                this.formDialogTitle = '扣款';
                this.tranType = 2;
                this.$refs.formDialog.open();
            },
            dialogSuccess(res) {
                this.doCheck(res, res => {
                    const result = res.contents;
                    this.showSuccess(result.optMsg);
                    this.$refs.formDialog.closeDialog();
                    this.getList();
                });
            },
            formatRechargeType(row, column, cellValue) {
                let value = '';
                this.rechargeTypes.forEach(item => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue;
                    }
                });
                return value ? value : '--';
            },
            dialogClose() {
                this.dialogModel = {
                    tatSimpleId: '',
                    tranAmt: '',
                    rechargeType: '',
                    remark: '',
                }
                this.dialogAmount = 0;
            },
            dialogOpen() {
                if (this.tranType == 3) {
                    this.doLoad(StatisticsService.statisGetRecharges, this.submitData, res => {
                        this.doCheck(res, res => {
                            const result = res.contents;
                            if (result) {
                                this.dialogAmount = result.tranAmt;
                            }
                        });
                    }, '信息获取失败')
                }
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(FinanceService.getRecharges, this.submitData, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.tableData = result.rows;

                        this.page.currentPage = result.current;
                        this.page.pageSize = result.size;
                        this.page.total = result.total;
                        this.isPage = false;
                    });
                }, '信息获取失败')
            },
            onSuccess(res) {
                this.doCheck(res, res => {
                    const result = res.contents;
                    this.tableData = result.rows;

                    this.page.currentPage = result.current;
                    this.page.pageSize = result.size;
                    this.page.total = result.total;
                    console.log('result', this.tableData)
                });
            },
        }
    }
</script>

<style scoped>
    .inner-button {
        position: absolute;
        right: 10px;
        z-index: 1;
    }

    .notice {
        font-size: 14px;
        color: #AAAAAA;
        margin-bottom: 10px;
    }

    .notice span {
        width: 70px;
        display: inline-block;
        text-align: right;
        margin-right: 10px;
        color: #606266;
    }

    .formSpan {
        width: auto;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/ServiceManage.vue